"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingSubCategory = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
exports.TrackingSubCategory = (0, type_utils_1.makeEnum)({
    // TODO: https://transcend.height.app/T-14003 - add more subcategories
    /** Fallback subcategory */
    Tracking: 'TRACKING',
});
//# sourceMappingURL=tracking.js.map